import type { TFunction } from 'i18next';
import { integrationRegistry } from '@/integrations/registry';
import type { IntegrationDefinition } from '@/integrations/types';

function getIntegrationDirectoryDisplayName(t: TFunction, def: IntegrationDefinition): string {
  switch (def.id) {
    case 'claude_desktop':
      return String(t('integrations.claudeDesktop.name', { ns: 'homepage' }));
    case 'custom_gpt_action':
      return String(t('integrations.chatgptActions.name', { ns: 'homepage' }));
    case 'slack_bot':
      return String(t('integrations.slackBot.name', { ns: 'homepage' }));
    case 'discord_bot':
      return String(t('integrations.discordBot.name', { ns: 'homepage' }));
    case 'microsoft_teams':
      return String(t('integrations.microsoftTeams.name', { ns: 'homepage' }));
    case 'telegram_bot':
      return String(t('integrations.telegramBot.name', { ns: 'homepage' }));
    case 'whatsapp_basic':
      return String(t('integrations.whatsappBasic.name', { ns: 'homepage' }));
    case 'whatsapp_business':
      return String(t('integrations.whatsappBusiness.name', { ns: 'homepage' }));
    case 'zapier':
      return String(t('integrations.zapier.name', { ns: 'homepage' }));
    case 'make_com':
      return String(t('integrations.makeCom.name', { ns: 'homepage' }));
    case 'n8n':
      return String(t('integrations.n8n.name', { ns: 'homepage' }));
    case 'ifttt':
      return String(t('integrations.ifttt.name', { ns: 'homepage' }));
    case 'notion':
      return String(t('integrations.notion.name', { ns: 'homepage' }));
    case 'google_workspace':
      return String(t('integrations.googleWorkspace.name', { ns: 'homepage' }));
    case 'github':
      return String(t('integrations.github.name', { ns: 'homepage' }));
    case 'cursor':
      return String(t('integrations.cursor.name', { ns: 'homepage' }));
    case 'chrome_extension':
      return String(t('integrations.chromeExtensionIntegration.name', { ns: 'homepage' }));
    case 'twitter_bookmarks':
      return String(t('integrations.twitterBookmarks.name', { ns: 'homepage' }));
    case 'bare_api':
      return String(t('integrations.bareApi.name', { ns: 'homepage' }));
    case 'bare_mcp':
      return String(t('integrations.bareMcp.name', { ns: 'homepage' }));
    case 'dify':
      return String(t('directory.names.dify', { ns: 'integrations' }));
    default:
      return def.name;
  }
}

export type IntegrationDirectoryEntry = {
  id: string;
  icon: string;
  displayName: string;
  landingPagePath?: string;
};

export function getIntegrationDirectoryEntries(t: TFunction): IntegrationDirectoryEntry[] {
  const items = Object.values(integrationRegistry).filter(
    (def): def is IntegrationDefinition =>
      def.status !== 'concept' && typeof def.icon === 'string'
  );
  return items
    .map((def) => ({
      id: def.id,
      icon: def.icon as string,
      displayName: getIntegrationDirectoryDisplayName(t, def),
      landingPagePath: def.components.landingPagePath,
    }))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
